


















import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'TopBarContainer',
})
export default class TopBarContainer extends Vue {}
